(() => {
  const isMobile = window.matchMedia('(max-width: 749px)').matches; // Sense mobile breakpoint-ish
  if (!isMobile) return; // רק מובייל

  let blockUntil = 0;
  const now = () => Date.now();
  const shouldBlock = () => now() < blockUntil;

  const armBlock = (ms = 350) => {
    blockUntil = Math.max(blockUntil, now() + ms);
  };

  // --- Patch scroll methods (only block during the short window) ---
  const origScrollTo = window.scrollTo.bind(window);
  const origScrollBy = window.scrollBy.bind(window);
  const origSIV = Element.prototype.scrollIntoView;
  const origFocus = HTMLElement.prototype.focus;

  window.scrollTo = function (...args) {
    if (shouldBlock()) return;
    return origScrollTo(...args);
  };

  window.scrollBy = function (...args) {
    if (shouldBlock()) return;
    return origScrollBy(...args);
  };

  Element.prototype.scrollIntoView = function (...args) {
    if (shouldBlock()) return;
    return origSIV.apply(this, args);
  };

  // Prevent focus from scrolling during the block window
  HTMLElement.prototype.focus = function (options) {
    if (shouldBlock()) {
      try {
        return origFocus.call(this, { preventScroll: true });
      } catch (e) {
        return origFocus.call(this);
      }
    }
    return origFocus.call(this, options);
  };

  // Arm the block when user interacts with variant pickers
  document.addEventListener(
    'pointerdown',
    (e) => {
      if (e.target.closest('variant-radios, variant-selects, .product-form__input, .product-form__input--pill')) {
        armBlock(400);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (e) => {
      if (e.target.closest('variant-radios, variant-selects')) {
        armBlock(400);
      }
    },
    true
  );

  // Also arm block inside media-gallery setActiveMedia (covers internal calls)
  const patchMediaGallery = () => {
    const MediaGallery = customElements.get('media-gallery');
    if (!MediaGallery?.prototype?.setActiveMedia) return false;
    if (MediaGallery.prototype.__noScrollPatchedMobile) return true;

    const original = MediaGallery.prototype.setActiveMedia;
    MediaGallery.prototype.setActiveMedia = function (...args) {
      armBlock(400);
      return original.apply(this, args);
    };

    MediaGallery.prototype.__noScrollPatchedMobile = true;
    return true;
  };

  if (!patchMediaGallery()) {
    customElements.whenDefined('media-gallery').then(patchMediaGallery);
  }
})();